export default __webpack_public_path__ + "static/media/qr_appstore_yokara.2bd797ca.svg";